import controller from './kform-content.controller';
import template from './kform-content.html';
import './kform-content.scss';

export default {
	controller,
	controllerAs: '$ctrl',
	template,
	bindings:     {
		kid:     '<',
		options: '<?',
	},
	require: {
		kform: '^^kform',
	},
};
